import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=67419223&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=ts"
export * from "./SettingsPage.vue?vue&type=script&lang=ts"
import style0 from "./SettingsPage.vue?vue&type=style&index=0&id=67419223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67419223",
  null
  
)

export default component.exports